module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5f7a79af3db62e0f5b7306ac0bd5ebf9.svg";